import {
  Box,
  SimpleGrid,
  Button,
  useDisclosure,
  useToast,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  useColorModeValue,
  InputGroup,
  InputLeftElement,
  Image,
  VStack,
  HStack,
  Flex,
  Icon,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading,
  Switch,
  Card,
  Badge,
  Avatar,
  Checkbox,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Radio,
  RadioGroup,
  Textarea,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { MdVisibility, MdEdit, MdDelete, MdSearch, MdMoreVert, MdAdd, MdPersonAdd, MdFemale, MdMale, MdGridView, MdList, MdArrowUpward, MdAssignment, MdChevronLeft, MdChevronRight, MdCameraAlt, MdPhone, MdEmail, MdLocationOn, MdDescription, MdPictureAsPdf, MdAccessTime, MdLocalHospital } from "react-icons/md";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Document, Page, Text as PdfText, View as PdfView, Image as PdfImage, StyleSheet, pdf } from "@react-pdf/renderer";
import { BASE_URL } from "config/api";
import { getPatients, getPatient, updatePatient, deletePatient, createPatient, checkToken, getUser, getRapportsMedicauxByPatient } from "../../../api/api";
import { useNavbarAction } from "contexts/NavbarActionContext";
import { generateRapportMedicalPDF } from "../../../services/rapportMedicalPdfService";
import LoadingSpinner from "components/LoadingSpinner";
import { validateEmail, validatePhone, validationMessages } from "utils/validation";
import nombrePatientIcon from "assets/img/icons/Patients/nombre_patient.png";
import nouveauxPatientIcon from "assets/img/icons/Patients/nouveaux_patient.png";
import femmeIcon from "assets/img/icons/Patients/femme.png";
import hommeIcon from "assets/img/icons/Patients/homme.png";
import rapportTemplateImage from "assets/img/template.png";

export default function PatientSettings() {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [viewData, setViewData] = useState(null);
  const cancelRef = useRef();
  const toast = useToast();
  const navigate = useNavigate();
  const { setOnCreatePatient, showStats, setShowStats, navbarHeight } = useNavbarAction();
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [viewMode, setViewMode] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  // Pagination côté serveur
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [patientMissions, setPatientMissions] = useState([]);
  const [patientRapportsMedicaux, setPatientRapportsMedicaux] = useState([]);
  const [missionUsers, setMissionUsers] = useState([]);
  const [missionSearchQuery, setMissionSearchQuery] = useState("");
  const [missionStatusFilter, setMissionStatusFilter] = useState("all");
  const [missionSortBy, setMissionSortBy] = useState("latest");
  const [missionCurrentPage, setMissionCurrentPage] = useState(1);
  const [missionItemsPerPage, setMissionItemsPerPage] = useState(20);
  const [selectedMissions, setSelectedMissions] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [rapportViewMode, setRapportViewMode] = useState("list"); // Vue pour les rapports médicaux

  // Edit Modal
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const [editData, setEditData] = useState(null);
  const [initialData, setInitialData] = useState(null);

  // Add Modal
  const {
    isOpen: isAddOpen,
    onOpen: onAddOpen,
    onClose: onAddClose,
  } = useDisclosure();
  const [newPatientData, setNewPatientData] = useState({
    nom: "",
    prenom: "",
    email: "",
    téléphone: "",
    ville: "",
    date_naissance: "",
    adresse: "",
    ipp: "",
    cin: "",
    sexe: "",
    age: "",
  });
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);

  // Liste des villes du Maroc
  const villesMaroc = [
    "Agadir", "Agdz", "Aït Melloul", "Al Hoceïma", "Arfoud", "Asilah", "Azemmour", "Azrou", "Beni Mellal", "Ben Guerir", "Berkane", "Berrechid", "Bouarfa", "Boujdour", "Boulemane", "Bouskoura", "Casablanca", "Chefchaouen", "Chichaoua", "Dakhla", "Demnate", "Drarga", "El Hajeb", "El Jadida", "Errachidia", "Essaouira", "Fès", "Fnideq", "Guelmim", "Guercif", "Ifrane", "Imzouren", "Inezgane", "Jerada", "Jorf El Melha", "Kénitra", "Khémisset", "Khénifra", "Khouribga", "Ksar El Kebir", "Laâyoune", "Larache", "Lqliaa", "Marrakech", "Martil", "Meknès", "Midelt", "Mohammédia", "Nador", "Nouaceur", "Ouarzazate", "Oued Zem", "Oujda", "Oulad Teima", "Rabat", "Rissani", "Rommani", "Safi", "Salé", "Sefrou", "Settat", "Sidi Bennour", "Sidi Ifni", "Sidi Kacem", "Sidi Slimane", "Skhirat", "Tafraout", "Tan-Tan", "Tanger", "Taourirt", "Tarfaya", "Taroudant", "Taza", "Témara", "Tétouan", "Tiflet", "Youssoufia", "Tiznit", "Zagora"
  ];

  const {
    isOpen: isAlertOpen,
    onOpen: onAlertOpen,
    onClose: onAlertClose,
  } = useDisclosure();

  // View Modal
  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  // Configurer le contexte NavbarActionContext pour la navbar
  useEffect(() => {
    setOnCreatePatient(() => onAddOpen);
    return () => {
      setOnCreatePatient(null);
    };
  }, [onAddOpen, setOnCreatePatient]);

  useEffect(() => {
    const checkTokenAndUser = async () => {
      try {
        // 1. Vérifier la validité de la session
        const check = await checkToken(); // le backend lit le cookie
        if (!check.data.valid) {
          navigate('/auth/sign-in');
          return;
        }

        // 2. Récupérer les infos utilisateur
        const user = await getUser(); // le backend lit le cookie
        const userRole = user.rôle || user['rÃ´le'] || user.role;
        if (
          userRole !== 'admin' &&
          userRole !== 'régulateur' &&
          userRole !== 'rÃ©gulateur' &&
          userRole !== 'médecin regulateur' &&
          userRole !== 'medecin regulateur'
        ) {
          navigate('/auth/sign-in');
          return;
        }

        // Si tout est ok, on charge les données
        fetchData();
      } catch (error) {
        console.error("Error:", error);
        navigate('/auth/sign-in');
      }
    };
    checkTokenAndUser();
  }, [navigate]);


  useEffect(() => {
    fetchData();
  }, [currentPage, itemsPerPage]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const patientsRes = await getPatients(currentPage, itemsPerPage);

      // Support pour la nouvelle structure paginée et l'ancienne structure (tableau)
      if (patientsRes.data && patientsRes.data.data) {
        // Nouvelle structure avec pagination
        setTableData(patientsRes.data.data);
        setTotalItems(patientsRes.data.pagination.total);
        setTotalPages(patientsRes.data.pagination.totalPages);
      } else if (Array.isArray(patientsRes.data)) {
        // Ancienne structure (tableau direct)
        setTableData(patientsRes.data);
        setTotalItems(patientsRes.data.length);
        setTotalPages(Math.ceil(patientsRes.data.length / itemsPerPage));
      }
    } catch (err) {
      console.error("Fetch error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Error fetching data", status: "error", isClosable: true });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (id) => {
    try {
      const res = await getPatient(id);
      setInitialData(res.data);
      setEditData({ ...res.data });
      setSelectedId(id);
      onEditOpen();
    } catch (err) {
      console.error("Edit fetch error:", err);
      console.error("Error details:", err.response?.data);
    }
  };

  const handleSave = async () => {
    try {
      await updatePatient(selectedId, editData);
      setTableData(prevData => {
        const newData = prevData.map(item => item.id === selectedId ? { ...item, ...editData } : item);
        return newData;
      });
      toast({ title: "Updated", status: "success", isClosable: true });
      onEditClose();
      setEditData(null);
      setInitialData(null);
    } catch (err) {
      console.error("Save error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Update failed", status: "error", isClosable: true });
    }
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.match(/image\/(jpg|jpeg|png|gif)/)) {
      toast({ title: 'Format invalide. Utilisez JPG, PNG ou GIF', status: 'error', isClosable: true });
      return;
    }

    // Validate file size (2MB max)
    if (file.size > 2 * 1024 * 1024) {
      toast({ title: 'Le fichier ne doit pas dépasser 2 Mo', status: 'error', isClosable: true });
      return;
    }

    setProfilePhoto(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setPhotoPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleAdd = async () => {
    const requiredFields = [
      "nom",
      "prenom",
      "email",
      "téléphone",
      "ville",
      "date_naissance",
      "adresse",
      "ipp",
      "cin",
      "sexe",
      "age",
    ];
    for (let field of requiredFields) {
      if (!newPatientData[field] || newPatientData[field] === "") {
        let fieldLabel = field;
        if (field === "nom") fieldLabel = "Nom";
        if (field === "prenom") fieldLabel = "Prénom";
        if (field === "ipp") fieldLabel = "IPP (Identifiant Permanent du Patient)";
        if (field === "cin") fieldLabel = "CIN (Carte d’Identité Nationale)";
        if (field === "sexe") fieldLabel = "Sexe";
        if (field === "age") fieldLabel = "Âge";
        toast({ title: `Veuillez remplir le champ "${fieldLabel}"`, status: "error", isClosable: true });
        return;
      }
    }
    // Validation de l'email
    if (!validateEmail(newPatientData.email)) {
      toast({
        title: validationMessages.email.invalid,
        status: "error",
        isClosable: true,
        duration: 4000
      });
      return;
    }

    // Validation du téléphone  
    if (!validatePhone(newPatientData.téléphone)) {
      toast({
        title: validationMessages.phone.invalid,
        status: "error",
        isClosable: true,
        duration: 4000
      });
      return;
    }

    // Validation du champ âge
    if (isNaN(newPatientData.age) || parseInt(newPatientData.age) <= 0) {
      toast({ title: "L'âge doit être un nombre entier positif.", status: "error", isClosable: true });
      return;
    }
    try {
      const patientData = {
        ...newPatientData,
      };
      const response = await createPatient(patientData);
      setTableData(prevData => {
        const newData = [...prevData, { ...patientData, id: response.data.id }];
        return newData;
      });
      toast({ title: "Patient ajouté avec succès", status: "success", isClosable: true });
      onAddClose();
      setNewPatientData({
        nom: "",
        prenom: "",
        email: "",
        téléphone: "",
        ville: "",
        date_naissance: "",
        adresse: "",
        ipp: "",
        cin: "",
        sexe: "",
        age: "",
      });
      setProfilePhoto(null);
      setPhotoPreview(null);
    } catch (err) {
      console.error("Add error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Erreur lors de l'ajout", status: "error", isClosable: true });
    }
  };

  const handleCloseEdit = () => {
    if (JSON.stringify(editData) !== JSON.stringify(initialData)) {
      const confirmClose = window.confirm("Unsaved changes detected. Do you want to discard?");
      if (!confirmClose) return;
    }
    onEditClose();
  };

  const handleRemove = (id) => {
    setSelectedId(id);
    onAlertOpen();
  };

  const confirmDelete = async () => {
    try {
      await deletePatient(selectedId);
      toast({ title: "Deleted", status: "success", isClosable: true });
      onAlertClose();
      setTableData(prevData => {
        const newData = prevData.filter(item => item.id !== selectedId);
        return newData;
      });
    } catch (err) {
      console.error("Delete error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Delete failed", status: "error", isClosable: true });
    }
  };

  const updateField = (field, value) => {
    setEditData(prev => ({ ...prev, [field]: value }));
  };

  const updateAddField = (field, value) => {
    setNewPatientData(prev => ({ ...prev, [field]: value }));
  };

  const handleView = async (id) => {
    try {
      const res = await getPatient(id);
      setViewData(res.data);
      setActiveTabIndex(0); // Réinitialiser l'onglet actif

      // Récupérer les missions du patient
      try {
        const missionsRes = await axios.get(`${BASE_URL}/missions`, {
          withCredentials: true
        });
        const patientMissionsList = missionsRes.data.filter(m => m.patient_id === parseInt(id) || m.patient_id == id);
        setPatientMissions(patientMissionsList);

        // Récupérer les utilisateurs pour afficher les noms
        const usersRes = await axios.get(`${BASE_URL}/users`, {
          withCredentials: true
        });
        setMissionUsers(usersRes.data);
      } catch (err) {
        console.error("Error fetching missions:", err);
      }

      // Récupérer les rapports médicaux du patient
      try {
        const rapportsRes = await getRapportsMedicauxByPatient(id);
        setPatientRapportsMedicaux(rapportsRes.data || []);
      } catch (err) {
        console.error("Error fetching rapports medicaux:", err);
        setPatientRapportsMedicaux([]);
      }

      onViewOpen();
    } catch (err) {
      console.error("View error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Error fetching patient details", status: "error", isClosable: true });
    }
  };

  const getMissionUserName = (userId) => {
    if (!userId) return 'N/A';
    const user = missionUsers.find(u => u.id == userId);
    return user ? `${user.prenom} ${user.nom}` : 'N/A';
  };

  const getMissionUserRole = (userId) => {
    if (!userId) return '';
    const user = missionUsers.find(u => u.id == userId);
    return user?.rôle || user?.role || '';
  };

  const handleGeneratePDF = async (rapport) => {
    try {
      // Récupérer les informations du médecin connecté
      const currentUser = await getUser();

      // Préparer les données du médecin
      const medecinData = {
        nom: rapport.medecin_nom || currentUser.nom,
        prenom: rapport.medecin_prenom || currentUser.prenom,
        email: rapport.medecin_email || currentUser.email
      };

      // Préparer les données de la mission (si disponible)
      const missionData = patientMissions.find(m => m.id === rapport.mission_id) || null;

      // Générer le PDF
      const result = await generateRapportMedicalPDF(
        rapport,
        missionData,
        viewData, // données du patient
        medecinData,
        null // signature (optionnel)
      );

      if (result.success) {
        toast({
          title: "PDF généré avec succès",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error(result.error);
      }
    } catch (error) {
      console.error("Erreur lors de la génération du PDF:", error);
      toast({
        title: "Erreur lors de la génération du PDF",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };


  const mappedTableData = useMemo(() => {

    return tableData.map((row) => {
      const mappedRow = {
        id: row.id,
        nom: row.nom || '',
        prenom: row.prenom || '',
        email: row.email || '',
        type_client: row.type_client || '',
        téléphone: row.téléphone || '',
        ville: row.ville || '',
        date_naissance: row.date_naissance || '',
        genre: row.genre || row.sexe || '',
        ipp: row.ipp || '',
        cin: row.cin || '',
        derniere_mission: row.derniere_mission || null,
      };
      return mappedRow;
    });
  }, [tableData]);

  // Calcul des statistiques (utiliser totalItems pour les stats globales)
  const stats = useMemo(() => {
    // Utiliser totalItems (nombre total de patients dans la base) pour les statistiques globales
    const total = totalItems || mappedTableData.length;
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

    // Pour les nouveaux patients, on utilise une approximation basée sur l'ID
    // Si vous avez un champ created_at dans votre API, utilisez-le à la place
    const newPatients = Math.floor(total * 0.04); // Approximation: 4% des patients

    // Calculer les genres à partir des données actuellement chargées
    const femmes = mappedTableData.filter(patient => {
      const genre = patient.genre || '';
      return genre.toLowerCase() === 'femme' || genre.toLowerCase() === 'f' || genre.toLowerCase() === 'female';
    }).length;

    const hommes = mappedTableData.filter(patient => {
      const genre = patient.genre || '';
      return genre.toLowerCase() === 'homme' || genre.toLowerCase() === 'h' || genre.toLowerCase() === 'm' || genre.toLowerCase() === 'male';
    }).length;

    return {
      total,
      newPatients: newPatients > 0 ? newPatients : 24, // Valeur par défaut si calcul = 0
      femmes: femmes > 0 ? femmes : Math.floor(total * 0.19), // Approximation si pas de données
      hommes: hommes > 0 ? hommes : total - Math.floor(total * 0.19), // Le reste
    };
  }, [mappedTableData, totalItems]);

  const filteredData = useMemo(() => {
    let filtered = mappedTableData;

    // Filtre par recherche (côté client pour les données déjà chargées)
    if (searchQuery) {
      filtered = filtered.filter((row) => {
        const searchFields = [
          row.nom,
          row.prenom,
          row.email,
          row.type_client,
          row.téléphone,
          row.ville,
          row.date_naissance,
          row.ipp,
          row.cin,
        ];

        return searchFields.some(field =>
          field && field.toLowerCase().includes(searchQuery.toLowerCase())
        );
      });
    }

    // Filtre par statut (si vous avez un champ statut)
    if (statusFilter !== "all") {
      // Ajoutez la logique de filtrage par statut ici
    }

    return filtered;
  }, [mappedTableData, searchQuery, statusFilter]);

  // Pagination côté serveur - pas de slice nécessaire
  const paginatedData = searchQuery ? filteredData : mappedTableData;
  const displayTotalPages = searchQuery ? Math.ceil(filteredData.length / itemsPerPage) : totalPages;
  const displayTotalItems = searchQuery ? filteredData.length : totalItems;

  // Pour la recherche locale, on pagine les résultats filtrés
  const startIndex = searchQuery ? (currentPage - 1) * itemsPerPage : 0;
  const endIndex = searchQuery ? startIndex + itemsPerPage : mappedTableData.length;
  const displayedData = searchQuery ? filteredData.slice(startIndex, endIndex) : paginatedData;

  const handleSelectPatient = (id) => {
    setSelectedPatients(prev =>
      prev.includes(id) ? prev.filter(pid => pid !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedPatients.length === displayedData.length) {
      setSelectedPatients([]);
    } else {
      setSelectedPatients(displayedData.map(row => row.id));
    }
  };

  if (loading) {
    return (
      <Box minH="100vh" bg={bgColor} p={6}>
        <Box maxW="9xl" mx="auto" mt={50}>
          <LoadingSpinner message="Chargement des patients..." size="lg" fullHeight />
        </Box>
      </Box>
    );
  }


  const topPadding = navbarHeight > 0 ? `${navbarHeight}px` : '200px';

  return (
    <Box minH="100vh" bg={bgColor} px={6} pb={6} pt={0}>
      <Box maxW="9xl" mx="auto" pt={topPadding} transition="padding-top 0.3s ease">
        <VStack spacing={6} align="stretch">

          {/* Statistics Section */}
          {showStats && (
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={6}>
              {/* Nombre total de patients */}
              <Card bg={cardBg} borderRadius="12px" p={4} minH="140px">
                <VStack align="start" spacing={2} h="100%" justify="space-between">
                  <HStack spacing={2} w="100%" justify="space-between">
                    <Text fontSize="sm" color="gray.600" fontWeight="medium">
                      Nombre total de patients
                    </Text>
                    <Box
                      w="40px"
                      h="40px"
                      borderRadius="8px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Image src={nombrePatientIcon} w="20px" h="20px" />
                    </Box>
                  </HStack>
                  <HStack spacing={2}>
                    <Text fontSize="2xl" fontWeight="bold" color="gray.900">
                      {stats.total}
                    </Text>
                    <HStack spacing={1} color="green.500">
                      <Icon as={MdArrowUpward} w="14px" h="14px" />
                      <Text fontSize="sm" fontWeight="medium">+19%</Text>
                    </HStack>
                  </HStack>
                  <Text fontSize="xs" color="gray.500">
                    Par rapport au mois dernier
                  </Text>
                </VStack>
              </Card>

              {/* Nouveaux Patients */}
              <Card bg={cardBg} borderRadius="12px" p={4} minH="140px">
                <VStack align="start" spacing={2} h="100%" justify="space-between">
                  <HStack spacing={2} w="100%" justify="space-between">
                    <Text fontSize="sm" color="gray.600" fontWeight="medium">
                      Nouveaux Patients (30 jours)
                    </Text>
                    <Box
                      w="40px"
                      h="40px"
                      borderRadius="8px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Image src={nouveauxPatientIcon} w="25px" h="25px" />
                    </Box>
                  </HStack>
                  <HStack spacing={2}>
                    <Text fontSize="2xl" fontWeight="bold" color="gray.900">
                      {stats.newPatients}
                    </Text>
                    <HStack spacing={1} color="green.500">
                      <Icon as={MdArrowUpward} w="14px" h="14px" />
                      <Text fontSize="sm" fontWeight="medium">+2%</Text>
                    </HStack>
                  </HStack>
                  <Text fontSize="xs" color="gray.500">
                    Par rapport au mois dernier
                  </Text>
                </VStack>
              </Card>

              {/* Femme */}
              <Card bg={cardBg} borderRadius="12px" p={4} minH="140px">
                <VStack align="start" spacing={2} h="100%" justify="space-between">
                  <HStack spacing={2} w="100%" justify="space-between">
                    <Text fontSize="sm" color="gray.600" fontWeight="medium">
                      Femme
                    </Text>
                    <Box
                      w="40px"
                      h="40px"
                      borderRadius="8px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Image src={femmeIcon} w="25px" h="30px" />
                    </Box>
                  </HStack>
                  <HStack spacing={2}>
                    <Text fontSize="2xl" fontWeight="bold" color="gray.900">
                      {stats.femmes}
                    </Text>
                    <HStack spacing={1} color="green.500">
                      <Icon as={MdArrowUpward} w="14px" h="14px" />
                      <Text fontSize="sm" fontWeight="medium">+19%</Text>
                    </HStack>
                  </HStack>
                  <Text fontSize="xs" color="gray.500">
                    Par rapport au mois dernier
                  </Text>
                </VStack>
              </Card>

              {/* Homme */}
              <Card bg={cardBg} borderRadius="12px" p={4} minH="140px">
                <VStack align="start" spacing={2} h="100%" justify="space-between">
                  <HStack spacing={2} w="100%" justify="space-between">
                    <Text fontSize="sm" color="gray.600" fontWeight="medium">
                      Homme
                    </Text>
                    <Box
                      w="40px"
                      h="40px"
                      borderRadius="8px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Image src={hommeIcon} w="25px" h="30px" />
                    </Box>
                  </HStack>
                  <HStack spacing={2}>
                    <Text fontSize="2xl" fontWeight="bold" color="gray.900">
                      {stats.hommes}
                    </Text>
                    <HStack spacing={1} color="green.500">
                      <Icon as={MdArrowUpward} w="14px" h="14px" />
                      <Text fontSize="sm" fontWeight="medium">+19%</Text>
                    </HStack>
                  </HStack>
                  <Text fontSize="xs" color="gray.500">
                    Par rapport au mois dernier
                  </Text>
                </VStack>
              </Card>
            </SimpleGrid>
          )}

          {/* Liste des patients */}
          <Card bg={cardBg} borderRadius="12px" p={6}>
            <VStack align="stretch" spacing={4}>
              <Text fontSize="lg" fontWeight="bold" color="gray.900">
                Liste des patients
              </Text>

              {/* Filtres et recherche */}
              <HStack spacing={4} flexWrap="wrap">
                <InputGroup flex={1} minW="200px">
                  <InputLeftElement pointerEvents="none">
                    <Icon as={MdSearch} color="gray.400" />
                  </InputLeftElement>
                  <Input
                    placeholder="Recherche d'une patients..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }}
                    bg="white"
                  />
                </InputGroup>

                <Select
                  value={statusFilter}
                  onChange={(e) => {
                    setStatusFilter(e.target.value);
                    setCurrentPage(1);
                  }}
                  w="150px"
                  bg="white"
                >
                  <option value="all">Statut: Tous</option>
                  <option value="actif">Actif</option>
                  <option value="inactif">Inactif</option>
                </Select>
                <HStack spacing={2}>
                  <IconButton
                    icon={<MdGridView />}
                    aria-label="Vue grille"
                    variant={viewMode === 'grid' ? 'solid' : 'outline'}
                    colorScheme={viewMode === 'grid' ? 'blue' : 'gray'}
                    size="sm"
                    onClick={() => setViewMode('grid')}
                  />
                  <IconButton
                    icon={<MdList />}
                    aria-label="Vue liste"
                    variant={viewMode === 'list' ? 'solid' : 'outline'}
                    colorScheme={viewMode === 'list' ? 'blue' : 'gray'}
                    size="sm"
                    onClick={() => setViewMode('list')}
                  />
                </HStack>
              </HStack>

              {/* Table */}
              {viewMode === 'list' ? (
                <TableContainer border="1px solid" borderColor="gray.200" borderRadius="12px" overflowX="auto">
                  <Table variant="simple" minW="1300px" sx={{ 'th, td': { borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'gray.200', whiteSpace: 'nowrap' }, 'th:last-child, td:last-child': { borderRight: 'none' }, 'tr:last-child td': { borderBottom: 'none' } }}>
                    <Thead>
                      <Tr bg="gray.50">
                        <Th cursor="pointer" w="150px">IPP</Th>
                        <Th cursor="pointer" minW="250px">Patients</Th>
                        <Th cursor="pointer" w="150px">CIN</Th>
                        <Th cursor="pointer" minW="250px">Contact</Th>
                        <Th cursor="pointer" w="200px">Dernière mission</Th>
                        <Th w="100px">Actions</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {displayedData.map((row) => {
                        const isSelected = selectedPatients.includes(row.id);
                        const fullName = `${row.prenom || ''} ${row.nom || ''}`.trim();
                        let age = '';
                        if (row.date_naissance) {
                          try {
                            const birthDate = new Date(row.date_naissance);
                            if (!isNaN(birthDate.getTime())) {
                              age = new Date().getFullYear() - birthDate.getFullYear();
                            }
                          } catch (e) {
                            // Ignore date parsing errors
                          }
                        }
                        const gender = row.genre || 'Homme';
                        const genderDisplay = gender === 'Femme' || gender === 'F' || gender === 'female' ? 'Femme' : 'Homme';

                        return (
                          <Tr key={row.id} _hover={{ bg: 'gray.50' }}>
                            <Td fontWeight="medium">{row.ipp ? row.ipp : 'N/A'}</Td>
                            <Td>
                              <HStack spacing={2}>
                                <Avatar
                                  size="sm"
                                  name={fullName}
                                />
                                <VStack align="start" spacing={0}>
                                  <Text fontWeight="medium" fontSize="sm">
                                    {fullName}
                                  </Text>
                                  <Text fontSize="xs" color="gray.500">
                                    {age ? `${age}-${genderDisplay}` : genderDisplay}
                                  </Text>
                                </VStack>
                              </HStack>
                            </Td>
                            <Td>
                              {row.cin ? row.cin : 'N/A'}
                            </Td>
                            <Td>
                              <VStack align="start" spacing={0}>
                                <Text fontSize="xs" color="gray.600">{row.email}</Text>
                                <Text fontSize="xs" color="gray.500">{row.téléphone}</Text>
                              </VStack>
                            </Td>

                            <Td>
                              <Text fontSize="sm" color="gray.600">
                                {row.derniere_mission ? new Date(row.derniere_mission).toLocaleString("fr-FR", {
                                  year: 'numeric',
                                  month: '2-digit',
                                  day: '2-digit',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                }) : 'N/A'}
                              </Text>
                            </Td>
                            <Td>
                              < Menu>
                                <MenuButton
                                  as={IconButton}
                                  icon={<MdMoreVert />}
                                  variant="ghost"
                                  size="sm"
                                />
                                <MenuList>
                                  <MenuItem icon={<MdVisibility />} onClick={() => handleView(row.id)}>
                                    Voir
                                  </MenuItem>
                                  <MenuItem icon={<MdEdit />} onClick={() => handleEdit(row.id)}>
                                    Modifier
                                  </MenuItem>
                                  <MenuItem icon={<MdDelete />} onClick={() => handleRemove(row.id)} color="red.500">
                                    Supprimer
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              ) : (
                <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
                  {displayedData.map((row) => {
                    const fullName = `${row.prenom || ''} ${row.nom || ''}`.trim();
                    let age = '';
                    if (row.date_naissance) {
                      try {
                        const birthDate = new Date(row.date_naissance);
                        if (!isNaN(birthDate.getTime())) {
                          age = new Date().getFullYear() - birthDate.getFullYear();
                        }
                      } catch (e) {
                        // Ignore date parsing errors
                      }
                    }
                    const gender = row.genre || 'Homme';
                    const genderDisplay = gender === 'Femme' || gender === 'F' || gender === 'female' ? 'Femme' : 'Homme';
                    const patientId = `PT-${String(row.id).padStart(3, '0')}`;

                    return (
                      <Card
                        key={row.id}
                        bg="white"
                        borderRadius="12px"
                        p={4}
                        border="1px solid"
                        borderColor="gray.200"
                        _hover={{ shadow: 'md', transform: 'translateY(-2px)', transition: 'all 0.2s' }}
                        position="relative"
                        zIndex={1}
                        _focusWithin={{ zIndex: 10 }}
                      >
                        <VStack align="stretch" spacing={3}>
                          {/* Header avec photo, nom, ID et menu */}
                          <Flex justify="space-between" align="start">
                            <HStack spacing={3}>
                              <Avatar
                                size="md"
                                name={fullName}
                              />
                              <VStack align="start" spacing={0}>
                                <Text fontWeight="bold" fontSize="sm" color="gray.900">
                                  {fullName}
                                </Text>
                                <Text fontSize="xs" color="gray.500">
                                  {patientId} - {age ? `${age} ${genderDisplay}` : genderDisplay}
                                </Text>
                              </VStack>
                            </HStack>
                            <HStack spacing={2}>

                              <Menu>
                                <MenuButton
                                  as={IconButton}
                                  icon={<MdMoreVert />}
                                  variant="ghost"
                                  size="sm"
                                  aria-label="Options"
                                />
                                <MenuList zIndex={1000} boxShadow="0px 4px 12px 0px rgba(0,0,0,0.15)">
                                  <MenuItem icon={<MdVisibility />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleView(row.id);
                                  }}>
                                    Voir
                                  </MenuItem>
                                  <MenuItem icon={<MdEdit />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit(row.id);
                                  }}>
                                    Modifier
                                  </MenuItem>
                                  <MenuItem icon={<MdDelete />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemove(row.id);
                                  }} color="red.500">
                                    Supprimer
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </HStack>
                          </Flex>

                          {/* Informations de contact */}
                          <VStack align="stretch" spacing={2} pt={2} borderTop="1px solid" borderColor="gray.200">
                            <HStack justify="space-between">
                              <Text fontSize="xs" color="gray.600" fontWeight="medium">Email</Text>
                              <Text fontSize="xs" color="gray.900" isTruncated maxW="200px">
                                {row.email || 'N/A'}
                              </Text>
                            </HStack>
                            <HStack justify="space-between">
                              <Text fontSize="xs" color="gray.600" fontWeight="medium">Téléphone</Text>
                              <Text fontSize="xs" color="gray.900">
                                {row.téléphone || 'N/A'}
                              </Text>
                            </HStack>


                            <HStack justify="space-between">
                              <Text fontSize="xs" color="gray.600" fontWeight="medium">Dernière mission</Text>
                              <Text fontSize="xs" color="gray.900">
                                {row.derniere_mission ? new Date(row.derniere_mission).toLocaleString("fr-FR", {
                                  year: 'numeric',
                                  month: '2-digit',
                                  day: '2-digit',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                }) : 'N/A'}
                              </Text>
                            </HStack>
                          </VStack>
                        </VStack>
                      </Card>
                    );
                  })}
                </SimpleGrid>
              )}

              {/* Pagination */}
              <Flex justify="space-between" align="center" pt={4}>
                <HStack spacing={2}>
                  <Text fontSize="sm" color="gray.600">Afficher</Text>
                  <Select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    w="100px"
                    size="sm"
                    bg="white"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Select>
                  <Text fontSize="sm" color="gray.600">par page</Text>
                </HStack>
                <Text fontSize="sm" color="gray.600">
                  {searchQuery ? startIndex + 1 : (currentPage - 1) * itemsPerPage + 1} à {searchQuery ? Math.min(endIndex, displayTotalItems) : Math.min(currentPage * itemsPerPage, displayTotalItems)} sur {displayTotalItems}
                </Text>
                <HStack spacing={2}>
                  <IconButton
                    icon={<MdChevronLeft />}
                    aria-label="Page précédente"
                    size="sm"
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    isDisabled={currentPage === 1}
                  />
                  {(() => {
                    const pages = [];
                    const maxVisiblePages = 5;
                    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
                    let endPage = Math.min(displayTotalPages, startPage + maxVisiblePages - 1);

                    if (endPage - startPage + 1 < maxVisiblePages) {
                      startPage = Math.max(1, endPage - maxVisiblePages + 1);
                    }

                    for (let i = startPage; i <= endPage; i++) {
                      pages.push(
                        <Button
                          key={i}
                          size="sm"
                          variant={currentPage === i ? 'solid' : 'outline'}
                          colorScheme={currentPage === i ? 'blue' : 'gray'}
                          onClick={() => setCurrentPage(i)}
                        >
                          {i}
                        </Button>
                      );
                    }
                    return pages;
                  })()}
                  <IconButton
                    icon={<MdChevronRight />}
                    aria-label="Page suivante"
                    size="sm"
                    onClick={() => setCurrentPage(prev => Math.min(displayTotalPages, prev + 1))}
                    isDisabled={currentPage === displayTotalPages || displayTotalPages === 0}
                  />
                </HStack>
              </Flex>
            </VStack>
          </Card>
        </VStack>
      </Box>

      {/* Delete Confirmation */}
      <AlertDialog isOpen={isAlertOpen} leastDestructiveRef={cancelRef} onClose={onAlertClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Confirmer la suppression</AlertDialogHeader>
            <AlertDialogBody>Êtes-vous sûr de vouloir supprimer ce patient ?</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onAlertClose}>Annuler</Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>Supprimer</Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Edit Modal */}
      <Modal isOpen={isEditOpen} onClose={handleCloseEdit} size="3xl">
        <ModalOverlay />
        <ModalContent maxW="900px">
          <ModalHeader>Modifier le Patient</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {editData && (
              <SimpleGrid columns={2} spacing={8}>
                {/* Colonne gauche : infos générales */}
                <Box bg="gray.50" p={6} borderRadius="lg">
                  <Text fontSize="lg" fontWeight="bold" color="blue.500" mb={4}>Informations Générales</Text>
                  <VStack align="start" spacing={3}>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Nom</FormLabel>
                      <Input value={editData.nom} onChange={(e) => updateField("nom", e.target.value)} fontSize="md" color="gray.800" />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Prénom</FormLabel>
                      <Input value={editData.prenom} onChange={(e) => updateField("prenom", e.target.value)} fontSize="md" color="gray.800" />
                    </FormControl>
                    <FormControl isRequired>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Sexe </FormLabel>
                      <RadioGroup value={editData.sexe || ""} onChange={(value) => updateField("sexe", value)}>
                        <HStack spacing={5}>
                          <Radio value="homme">Homme</Radio>
                          <Radio value="femme">Femme</Radio>
                        </HStack>
                      </RadioGroup>
                    </FormControl>
                    <FormControl isRequired>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Âge </FormLabel>
                      <Input type="number" min={1} value={editData.age || ""} onChange={(e) => updateField("age", e.target.value.replace(/[^0-9]/g, ""))} fontSize="md" color="gray.800" placeholder="Saisissez l'âge du patient" />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">IPP (Identifiant Permanent du Patient) </FormLabel>
                      <Input value={editData.ipp || ""} onChange={(e) => updateField("ipp", e.target.value)} fontSize="md" color="gray.800" placeholder="Saisissez l'IPP du patient" />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">CIN (Carte d’Identité Nationale) </FormLabel>
                      <Input value={editData.cin || ""} onChange={(e) => updateField("cin", e.target.value)} fontSize="md" color="gray.800" placeholder="Saisissez le CIN du patient" />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Date de naissance</FormLabel>
                      <Input type="date" value={editData.date_naissance} onChange={(e) => updateField("date_naissance", e.target.value)} fontSize="md" color="gray.800" />
                    </FormControl>
                  </VStack>
                </Box>
                {/* Colonne droite : coordonnées */}
                <Box bg="gray.50" p={6} borderRadius="lg">
                  <Text fontSize="lg" fontWeight="bold" color="blue.500" mb={4}>Coordonnées</Text>
                  <VStack align="start" spacing={3}>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Email</FormLabel>
                      <Input type="email" value={editData.email} onChange={(e) => updateField("email", e.target.value)} fontSize="md" color="gray.800" />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Téléphone</FormLabel>
                      <Input value={editData.téléphone} onChange={(e) => updateField("téléphone", e.target.value)} fontSize="md" color="gray.800" />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold" color="gray.500" fontSize="sm">Ville</FormLabel>
                      <Input value={editData.ville} onChange={(e) => updateField("ville", e.target.value)} fontSize="md" color="gray.800" />
                    </FormControl>
                  </VStack>
                </Box>
              </SimpleGrid>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleSave}>
              Sauvegarder
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Add Modal */}
      <Modal isOpen={isAddOpen} onClose={onAddClose} size="6xl">
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <ModalContent
          boxShadow="2xl"
          maxH="100vh"
          h="100vh"
          overflow="hidden"
          display="flex"
          flexDirection="column"
          position="fixed"
          right={0}
          top={0}
          bottom={0}
          m={0}
          maxW="1200px"
          w="1200px"
          borderRadius="0"
          borderTopLeftRadius="12px"
          borderBottomLeftRadius="12px"
        >
          <ModalHeader fontSize="xl" fontWeight="bold" py={4} px={6} borderBottom="1px solid" borderColor="gray.200" bg="white" borderTopLeftRadius="12px">
            Créer une patient
          </ModalHeader>
          <ModalCloseButton top={4} right={4} borderRadius="full" _hover={{ bg: 'gray.100' }} />
          <ModalBody pb={6} px={6} pt={6}>
            <Box style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
                {/* Section gauche - Photo de profil */}
                <Box>
                  <Text fontSize="md" fontWeight="semibold" mb={4} color="gray.700">
                    Photo de profil
                  </Text>
                  <Box
                    border="2px dashed"
                    borderColor="gray.300"
                    borderRadius="12px"
                    p={10}
                    textAlign="center"
                    bg={photoPreview ? "transparent" : "gray.50"}
                    position="relative"
                    minH="400px"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {photoPreview ? (
                      <VStack spacing={4}>
                        <Avatar size="2xl" src={photoPreview} />
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => {
                            setProfilePhoto(null);
                            setPhotoPreview(null);
                            document.getElementById('photo-upload').value = '';
                          }}
                        >
                          Changer la photo
                        </Button>
                      </VStack>
                    ) : (
                      <VStack spacing={4}>
                        <Box
                          w="80px"
                          h="80px"
                          borderRadius="full"
                          bg="gray.200"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Icon as={MdCameraAlt} w="40px" h="40px" color="gray.500" />
                        </Box>
                        <VStack spacing={2}>
                          <Text fontSize="sm" color="gray.600" fontWeight="medium">
                            Téléchargez une photo de profil
                          </Text>
                          <Text fontSize="xs" color="gray.500">
                            Format: JPG, PNG ou GIF. 2 Mo maximum.
                          </Text>
                        </VStack>
                        <Input
                          id="photo-upload"
                          type="file"
                          accept="image/jpeg,image/jpg,image/png,image/gif"
                          onChange={handlePhotoUpload}
                          style={{ display: 'none' }}
                        />
                        <Button
                          size="md"
                          colorScheme="blue"
                          variant="outline"
                          onClick={() => document.getElementById('photo-upload').click()}
                        >
                          Télécharger une photo
                        </Button>
                      </VStack>
                    )}
                  </Box>
                </Box>

                {/* Section droite - Informations générales */}
                <Box>
                  <Text fontSize="md" fontWeight="semibold" mb={6} color="gray.700">
                    Informations générales
                  </Text>
                  <VStack spacing={5} align="stretch">
                    <FormControl isRequired>
                      <FormLabel>
                        Nom 
                      </FormLabel>
                      <Input
                        placeholder="Saisissez le nom"
                        value={newPatientData.nom}
                        onChange={(e) => updateAddField("nom", e.target.value)}
                      />
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>
                        Prénom 
                      </FormLabel>
                      <Input
                        placeholder="Saisissez le prénom"
                        value={newPatientData.prenom}
                        onChange={(e) => updateAddField("prenom", e.target.value)}
                      />
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>
                        Sexe 
                      </FormLabel>
                      <RadioGroup
                        value={newPatientData.sexe}
                        onChange={(value) => updateAddField("sexe", value)}
                      >
                        <HStack spacing={10} pt={2}>
                          <Radio value="homme">Homme</Radio>
                          <Radio value="femme">Femme</Radio>
                        </HStack>
                      </RadioGroup>
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>
                        Âge 
                      </FormLabel>
                      <Input
                        type="number"
                        min={1}
                        placeholder="Saisissez l'âge du patient"
                        value={newPatientData.age}
                        onChange={(e) => updateAddField("age", e.target.value.replace(/[^0-9]/g, ""))}
                      />
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>
                        IPP (Identifiant Permanent du Patient) 
                      </FormLabel>
                      <Input
                        placeholder="Saisissez l'IPP du patient"
                        value={newPatientData.ipp}
                        onChange={(e) => updateAddField("ipp", e.target.value)}
                      />
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>
                        CIN (Carte d’Identité Nationale) 
                      </FormLabel>
                      <Input
                        placeholder="Saisissez le CIN du patient"
                        value={newPatientData.cin}
                        onChange={(e) => updateAddField("cin", e.target.value)}
                      />
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>
                        Date de naissance 
                      </FormLabel>
                      <Input
                        type="date"
                        value={newPatientData.date_naissance}
                        onChange={(e) => updateAddField("date_naissance", e.target.value)}
                      />
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>
                        E-mail 
                      </FormLabel>
                      <Input
                        type="email"
                        placeholder="Saisissez E-mail"
                        value={newPatientData.email}
                        onChange={(e) => updateAddField("email", e.target.value)}
                      />
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>
                        Téléphone 
                      </FormLabel>
                      <InputGroup>
                        <InputLeftElement w="80px">
                          <Select
                            defaultValue="+212"
                            borderRight="none"
                            borderRightRadius="0"
                            bg="gray.50"
                            fontSize="sm"
                          >
                            <option value="+212">+212</option>
                          </Select>
                        </InputLeftElement>
                        <Input
                          pl="90px"
                          placeholder="Saisissez numéro de téléphone"
                          value={newPatientData.téléphone}
                          onChange={(e) => updateAddField("téléphone", e.target.value)}
                        />
                      </InputGroup>
                    </FormControl>


                    <FormControl isRequired>
                      <FormLabel>
                        Ville 
                      </FormLabel>
                      <Select
                        placeholder="Sélectionner ville"
                        value={newPatientData.ville}
                        onChange={(e) => updateAddField("ville", e.target.value)}
                      >
                        {villesMaroc.map(ville => (
                          <option key={ville} value={ville}>
                            {ville}
                          </option>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>
                        Adresse 
                      </FormLabel>
                      <Textarea
                        placeholder="Saisissez Adresse"
                        value={newPatientData.adresse}
                        onChange={(e) => updateAddField("adresse", e.target.value)}
                        rows={3}
                      />
                    </FormControl>
                  </VStack>
                </Box>
              </SimpleGrid>
            </Box>
          </ModalBody>
          <ModalFooter py={4} px={6} borderTop="1px solid" borderColor="gray.200" bg="gray.50">
            <Button variant="ghost" mr={3} onClick={onAddClose} size="md">
              Annuler
            </Button>
            <Button colorScheme="blue" onClick={handleAdd} size="md">
              Ajouter
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* View Modal - Full Profile */}
      <Modal isOpen={isViewOpen} onClose={onViewClose} size="6xl">
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <ModalContent
          boxShadow="2xl"
          maxH="100vh"
          h="100vh"
          overflowY="auto"
          display="flex"
          flexDirection="column"
          position="fixed"
          right={0}
          top={0}
          bottom={0}
          m={0}
          maxW="1400px"
          w="1400px"
          borderRadius="0"
          borderTopLeftRadius="12px"
          borderBottomLeftRadius="12px"
          bg={bgColor}
        >
          {viewData && (
            <>
              {/* Header avec breadcrumbs */}
              <Box bg={cardBg} px={6} py={4} borderBottom="1px solid" borderColor="gray.200" borderTopLeftRadius="12px">
                <Breadcrumb fontSize="sm" mb={2}>
                  <BreadcrumbItem>
                    <BreadcrumbLink href="#" color="gray.600">Gestion des utilisateurs</BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <BreadcrumbLink href="#" color="gray.600">Les patients</BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink color="gray.900" fontWeight="medium">Détails de la patient</BreadcrumbLink>
                  </BreadcrumbItem>
                </Breadcrumb>
                <ModalCloseButton top={4} right={4} borderRadius="full" _hover={{ bg: 'gray.100' }} />
              </Box>

              {/* Patient Profile Header */}
              <Box bg={cardBg} px={6} py={6} borderBottom="1px solid" borderColor="gray.200" boxShadow="sm">
                <Flex align="start" justify="space-between">
                  <HStack spacing={6} flex={1}>
                    <Avatar size="2xl" name={`${viewData.prenom} ${viewData.nom}`} />
                    <VStack align="start" spacing={2}>
                      <HStack spacing={3}>
                        <Text fontSize="2xl" fontWeight="bold" color="gray.900">
                          #{`P-${String(viewData.id).padStart(3, '0')}`}
                        </Text>
                        <Text fontSize="2xl" fontWeight="bold" color="gray.900">
                          {viewData.prenom} {viewData.nom}
                        </Text>
                        <Badge colorScheme="blue" variant="subtle" fontSize="md" px={3} py={1}>
                          {viewData.type_client}
                        </Badge>
                      </HStack>
                      <HStack spacing={2} color="gray.600">
                        <Icon as={MdLocationOn} />
                        <Text fontSize="sm">
                          {viewData.adresse || `${viewData.ville || ''}, Maroc`}
                        </Text>
                      </HStack>
                      <HStack spacing={4} fontSize="xs" color="gray.500">
                        <Text>Registered on: {viewData.date_naissance ? new Date(viewData.date_naissance).toLocaleDateString("en-US") : 'N/A'}</Text>
                        <Text>Last Updated: {new Date().toLocaleDateString("en-US")}</Text>
                      </HStack>
                    </VStack>
                  </HStack>
                  <HStack spacing={3}>
                    <IconButton icon={<MdPhone />} aria-label="Appeler" variant="ghost" />
                    <IconButton icon={<MdEmail />} aria-label="Email" variant="ghost" />
                    <Button leftIcon={<MdAdd />} colorScheme="blue" size="sm">
                      Actif
                    </Button>
                    <Menu>
                      <MenuButton as={IconButton} icon={<MdMoreVert />} variant="ghost" />
                      <MenuList>
                        <MenuItem icon={<MdEdit />} onClick={() => handleEdit(viewData.id)}>
                          Modifier
                        </MenuItem>
                        <MenuItem icon={<MdDelete />} onClick={() => handleRemove(viewData.id)} color="red.500">
                          Supprimer
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </HStack>
                </Flex>

                {/* Tabs */}
                <Tabs variant="unstyled" mt={4} index={activeTabIndex} onChange={setActiveTabIndex}>
                  <TabList>
                    <Tab
                      _selected={{ color: 'blue.500', borderBottom: '2px solid', borderColor: 'blue.500' }}
                      fontWeight="medium"
                      px={4}
                      py={2}
                    >
                      Aperçu de la patient
                    </Tab>
                    <Tab
                      _selected={{ color: 'blue.500', borderBottom: '2px solid', borderColor: 'blue.500' }}
                      fontWeight="medium"
                      px={4}
                      py={2}
                    >
                      Missions {patientMissions.length > 0 ? patientMissions.length : '03'}
                    </Tab>
                    <Tab
                      _selected={{ color: 'blue.500', borderBottom: '2px solid', borderColor: 'blue.500' }}
                      fontWeight="medium"
                      px={4}
                      py={2}
                    >
                      Rapport medicale
                    </Tab>
                  </TabList>
                </Tabs>
              </Box>

              {/* Content */}
              <ModalBody px={6} py={6} flex={1} overflowY="auto" bg={bgColor}>
                <Tabs variant="unstyled" index={activeTabIndex} onChange={setActiveTabIndex}>
                  <TabPanels>
                    {/* Tab 1: Aperçu */}
                    <TabPanel px={0}>
                      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
                        {/* Informations Générales */}
                        <Card bg={cardBg} borderRadius="12px" p={6} border="1px solid" borderColor="gray.200" boxShadow="sm">
                          <Text fontSize="lg" fontWeight="bold" color="gray.900" mb={4}>
                            Informations Générales
                          </Text>
                          <VStack align="stretch" spacing={4}>
                            <Box>
                              <Text fontSize="xs" color="gray.500" mb={1}>Genre</Text>
                              <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                {viewData.genre === 'Femme' || viewData.genre === 'F' ? 'Femme' : 'Homme'}
                              </Text>
                            </Box>
                            <Box>
                              <Text fontSize="xs" color="gray.500" mb={1}>Date de naissance</Text>
                              <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                {viewData.date_naissance ? `${new Date(viewData.date_naissance).toLocaleDateString("fr-FR")} - ${new Date().getFullYear() - new Date(viewData.date_naissance).getFullYear()} ans` : 'N/A'}
                              </Text>
                            </Box>

                            <Box>
                              <Text fontSize="xs" color="gray.500" mb={1}>Dernière mission</Text>
                              <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                {viewData.derniere_mission ? new Date(viewData.derniere_mission).toLocaleString("fr-FR", {
                                  year: 'numeric',
                                  month: '2-digit',
                                  day: '2-digit',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                }) : 'N/A'}
                              </Text>
                            </Box>

                            <Box>
                              <Text fontSize="xs" color="gray.500" mb={1}>Ville</Text>
                              <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                {viewData.ville || 'N/A'}
                              </Text>
                            </Box>
                            <Box>
                              <Text fontSize="xs" color="gray.500" mb={1}>Adresse</Text>
                              <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                {viewData.adresse || 'N/A'}
                              </Text>
                            </Box>
                          </VStack>
                        </Card>

                        {/* Coordonnées */}
                        <Card bg={cardBg} borderRadius="12px" p={6} border="1px solid" borderColor="gray.200" boxShadow="sm">
                          <Text fontSize="lg" fontWeight="bold" color="gray.900" mb={4}>
                            Coordonnées
                          </Text>
                          <VStack align="stretch" spacing={4}>
                            <Box>
                              <Text fontSize="xs" color="gray.500" mb={1}>Email</Text>
                              <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                {viewData.email || 'N/A'}
                              </Text>
                            </Box>
                            <Box>
                              <Text fontSize="xs" color="gray.500" mb={1}>Téléphone</Text>
                              <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                {viewData.téléphone || 'N/A'}
                              </Text>
                            </Box>
                            <Box pt={2} borderTop="1px solid" borderColor="gray.200">
                              <Text fontSize="sm" fontWeight="semibold" color="gray.700" mb={3}>
                                Contact d'urgence
                              </Text>
                              <VStack align="stretch" spacing={3}>
                                <Box>
                                  <Text fontSize="xs" color="gray.500" mb={1}>Nom</Text>
                                  <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                    {viewData.prenom} {viewData.nom}
                                  </Text>
                                </Box>
                                <Box>
                                  <Text fontSize="xs" color="gray.500" mb={1}>Lien de parenté</Text>
                                  <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                    Conjoint
                                  </Text>
                                </Box>
                                <Box>
                                  <Text fontSize="xs" color="gray.500" mb={1}>Téléphone</Text>
                                  <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                    {viewData.téléphone || 'N/A'}
                                  </Text>
                                </Box>
                              </VStack>
                            </Box>
                          </VStack>
                        </Card>
                      </SimpleGrid>
                    </TabPanel>

                    {/* Tab 2: Missions */}
                    <TabPanel px={0}>
                      <VStack align="stretch" spacing={4}>
                        {/* Toolbar */}
                        <HStack spacing={4} flexWrap="wrap">
                          <InputGroup flex={1} minW="200px">
                            <InputLeftElement pointerEvents="none">
                              <Icon as={MdSearch} color="gray.400" />
                            </InputLeftElement>
                            <Input
                              placeholder="Recherche d'une mission..."
                              value={missionSearchQuery}
                              onChange={(e) => {
                                setMissionSearchQuery(e.target.value);
                                setMissionCurrentPage(1);
                              }}
                              bg="white"
                            />
                          </InputGroup>
                          <Select
                            value={missionStatusFilter}
                            onChange={(e) => {
                              setMissionStatusFilter(e.target.value);
                              setMissionCurrentPage(1);
                            }}
                            w="150px"
                            bg="white"
                          >
                            <option value="all">Statut: Tous</option>
                            <option value="Terminée">Statut: Terminée</option>
                            <option value="En cours">Statut: En cours</option>
                            <option value="Planifiée">Statut: Planifiée</option>
                            <option value="Annulée">Statut: Annulée</option>
                          </Select>
                          <Select
                            value={missionSortBy}
                            onChange={(e) => {
                              setMissionSortBy(e.target.value);
                              setMissionCurrentPage(1);
                            }}
                            w="150px"
                            bg="white"
                          >
                            <option value="latest">Trier par: Dernière</option>
                            <option value="oldest">Plus ancienne</option>
                          </Select>
                          <Button variant="outline" size="md" bg="white">
                            Export <Icon as={MdChevronRight} ml={1} />
                          </Button>
                          <HStack spacing={2}>
                            <IconButton
                              icon={<MdGridView />}
                              aria-label="Vue grille"
                              variant="outline"
                              size="sm"
                            />
                            <IconButton
                              icon={<MdList />}
                              aria-label="Vue liste"
                              variant="solid"
                              colorScheme="blue"
                              size="sm"
                            />
                          </HStack>
                          <Menu>
                            <MenuButton as={IconButton} icon={<MdMoreVert />} variant="ghost" size="sm" />
                            <MenuList>
                              <MenuItem>Options</MenuItem>
                            </MenuList>
                          </Menu>
                        </HStack>

                        {/* Table */}
                        <Card bg={cardBg} borderRadius="12px" border="1px solid" borderColor="gray.200" boxShadow="sm">
                          <TableContainer>
                            <Table variant="simple">
                              <Thead>
                                <Tr>
                                  <Th>
                                    <Checkbox
                                      isChecked={selectedMissions.length === patientMissions.length && patientMissions.length > 0}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSelectedMissions(patientMissions.map(m => m.id));
                                        } else {
                                          setSelectedMissions([]);
                                        }
                                      }}
                                    />
                                  </Th>
                                  <Th cursor="pointer">Référence</Th>
                                  <Th cursor="pointer">Ambulancier</Th>
                                  <Th cursor="pointer">Type Mission</Th>
                                  <Th cursor="pointer">Type Ambulance</Th>
                                  <Th cursor="pointer">Numéro</Th>
                                  <Th cursor="pointer">État d'Urgence</Th>
                                  <Th cursor="pointer">Date de création</Th>
                                  <Th cursor="pointer">Date de mission</Th>
                                  <Th cursor="pointer">Statut</Th>
                                  <Th>Actions</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {patientMissions.length === 0 ? (
                                  <Tr>
                                    <Td colSpan={11} textAlign="center" py={8}>
                                      <Text color="gray.500">Aucune mission disponible</Text>
                                    </Td>
                                  </Tr>
                                ) : (
                                  patientMissions.map((mission) => {
                                    const isSelected = selectedMissions.includes(mission.id);
                                    const ambulancierName = getMissionUserName(mission.ambulancier_id);
                                    const doctorName = getMissionUserName(mission.doctor_id);
                                    const nurseName = getMissionUserName(mission.nurse_id);
                                    const staffCount = [mission.ambulancier_id, mission.doctor_id, mission.nurse_id].filter(Boolean).length;

                                    return (
                                      <Tr key={mission.id} _hover={{ bg: 'gray.50' }}>
                                        <Td>
                                          <Checkbox
                                            isChecked={isSelected}
                                            onChange={(e) => {
                                              if (e.target.checked) {
                                                setSelectedMissions([...selectedMissions, mission.id]);
                                              } else {
                                                setSelectedMissions(selectedMissions.filter(id => id !== mission.id));
                                              }
                                            }}
                                          />
                                        </Td>
                                        <Td fontWeight="medium">REF-{String(mission.id).padStart(3, '0')}</Td>
                                        <Td>
                                          <HStack spacing={2}>
                                            <Avatar size="sm" name={ambulancierName || doctorName || nurseName} />
                                            <VStack align="start" spacing={0}>
                                              <Text fontSize="sm" fontWeight="medium">
                                                {doctorName !== 'N/A' ? `Dr. ${doctorName}` : ambulancierName !== 'N/A' ? ambulancierName : nurseName}
                                              </Text>
                                              {staffCount > 1 && (
                                                <Text fontSize="xs" color="gray.500">
                                                  +{staffCount - 1} autres
                                                </Text>
                                              )}
                                            </VStack>
                                          </HStack>
                                        </Td>
                                        <Td>
                                          <Text fontSize="sm">{mission.type_mission || 'N/A'}</Text>
                                        </Td>
                                        <Td>
                                          <Text fontSize="sm">{mission.type_ambulance || 'N/A'}</Text>
                                        </Td>
                                        <Td>
                                          <Text fontSize="sm">{mission.téléphone || 'N/A'}</Text>
                                        </Td>
                                        <Td>
                                          <Badge
                                            colorScheme={mission.etat_mission === 'urgente' ? 'red' : mission.etat_mission === 'planifiée' ? 'blue' : 'gray'}
                                            variant="solid"
                                            borderRadius="full"
                                            px={2}
                                            py={1}
                                          >
                                            {mission.etat_mission || 'N/A'}
                                          </Badge>
                                        </Td>
                                        <Td>
                                          <Text fontSize="sm" color="gray.600">
                                            {mission.date_mission ? new Date(mission.date_mission).toLocaleDateString("fr-FR") + ' ' + new Date(mission.date_mission).toLocaleTimeString("fr-FR", { hour: '2-digit', minute: '2-digit' }) : 'N/A'}
                                          </Text>
                                        </Td>
                                        <Td>
                                          <Text fontSize="sm" color="gray.600">
                                            {mission.date_mission ? new Date(mission.date_mission).toLocaleDateString("fr-FR") + ' ' + new Date(mission.date_mission).toLocaleTimeString("fr-FR", { hour: '2-digit', minute: '2-digit' }) : 'N/A'}
                                          </Text>
                                        </Td>
                                        <Td>
                                          <Badge
                                            colorScheme={mission.statut === 'Terminée' ? 'blue' : mission.statut === 'En cours' ? 'green' : 'gray'}
                                            variant="solid"
                                            borderRadius="full"
                                            px={2}
                                            py={1}
                                          >
                                            {mission.statut || 'N/A'}
                                          </Badge>
                                        </Td>
                                        <Td>
                                          <Menu>
                                            <MenuButton
                                              as={IconButton}
                                              icon={<MdMoreVert />}
                                              variant="ghost"
                                              size="sm"
                                            />
                                            <MenuList>
                                              <MenuItem icon={<MdVisibility />}>Voir</MenuItem>
                                              <MenuItem icon={<MdEdit />}>Modifier</MenuItem>
                                              <MenuItem icon={<MdDelete />} color="red.500">Supprimer</MenuItem>
                                            </MenuList>
                                          </Menu>
                                        </Td>
                                      </Tr>
                                    );
                                  })
                                )}
                              </Tbody>
                            </Table>
                          </TableContainer>

                          {/* Pagination */}
                          {patientMissions.length > 0 && (
                            <Flex justify="space-between" align="center" p={4} borderTop="1px solid" borderColor="gray.200">
                              <HStack spacing={2}>
                                <Text fontSize="sm" color="gray.600">Afficher</Text>
                                <Select
                                  value={missionItemsPerPage}
                                  onChange={(e) => {
                                    setMissionItemsPerPage(Number(e.target.value));
                                    setMissionCurrentPage(1);
                                  }}
                                  w="100px"
                                  size="sm"
                                  bg="white"
                                >
                                  <option value={10}>10</option>
                                  <option value={20}>20</option>
                                  <option value={50}>50</option>
                                  <option value={100}>100</option>
                                </Select>
                                <Text fontSize="sm" color="gray.600">par page</Text>
                              </HStack>
                              <Text fontSize="sm" color="gray.600">
                                1 à {Math.min(missionItemsPerPage, patientMissions.length)} sur {patientMissions.length}
                              </Text>
                              <HStack spacing={2}>
                                <IconButton
                                  icon={<MdChevronLeft />}
                                  aria-label="Page précédente"
                                  size="sm"
                                  isDisabled={missionCurrentPage === 1}
                                  onClick={() => setMissionCurrentPage(prev => Math.max(1, prev - 1))}
                                />
                                {[...Array(Math.min(5, Math.ceil(patientMissions.length / missionItemsPerPage)))].map((_, i) => {
                                  const pageNum = i + 1;
                                  return (
                                    <Button
                                      key={pageNum}
                                      size="sm"
                                      variant={missionCurrentPage === pageNum ? 'solid' : 'outline'}
                                      colorScheme={missionCurrentPage === pageNum ? 'blue' : 'gray'}
                                      onClick={() => setMissionCurrentPage(pageNum)}
                                    >
                                      {pageNum}
                                    </Button>
                                  );
                                })}
                                <IconButton
                                  icon={<MdChevronRight />}
                                  aria-label="Page suivante"
                                  size="sm"
                                  isDisabled={missionCurrentPage >= Math.ceil(patientMissions.length / missionItemsPerPage)}
                                  onClick={() => setMissionCurrentPage(prev => prev + 1)}
                                />
                              </HStack>
                            </Flex>
                          )}
                        </Card>
                      </VStack>
                    </TabPanel>
                    {/* Tab 3: Rapport medicale */}
                    <TabPanel px={0}>
                      <VStack align="stretch" spacing={4}>
                        {/* Toolbar */}
                        <HStack spacing={4} flexWrap="wrap">
                          <InputGroup flex={1} minW="200px">
                            <InputLeftElement pointerEvents="none">
                              <Icon as={MdSearch} color="gray.400" />
                            </InputLeftElement>
                            <Input
                              placeholder="Recherche d'un rapport médical..."
                              value={missionSearchQuery}
                              onChange={(e) => {
                                setMissionSearchQuery(e.target.value);
                                setMissionCurrentPage(1);
                              }}
                              bg="white"
                            />
                          </InputGroup>
                          <Select
                            value={missionStatusFilter}
                            onChange={(e) => {
                              setMissionStatusFilter(e.target.value);
                              setMissionCurrentPage(1);
                            }}
                            w="180px"
                            bg="white"
                          >
                            <option value="">Tous les statuts</option>
                            <option value="En attente">Statut: En attente</option>
                            <option value="En cours">Statut: En cours</option>
                            <option value="Terminée">Statut: Terminée</option>
                            <option value="Annulée">Statut: Annulée</option>
                          </Select>
                          <Select
                            value={missionSortBy}
                            onChange={(e) => {
                              setMissionSortBy(e.target.value);
                              setMissionCurrentPage(1);
                            }}
                            w="150px"
                            bg="white"
                          >
                            <option value="latest">Trier par: Dernière</option>
                            <option value="oldest">Plus ancienne</option>
                          </Select>
                          <Button variant="outline" size="md" bg="white">
                            Export <Icon as={MdChevronRight} ml={1} />
                          </Button>
                          <HStack spacing={2}>
                            <IconButton
                              icon={<MdGridView />}
                              aria-label="Vue grille"
                              variant={rapportViewMode === "grid" ? "solid" : "outline"}
                              colorScheme={rapportViewMode === "grid" ? "blue" : "gray"}
                              size="sm"
                              onClick={() => setRapportViewMode("grid")}
                            />
                            <IconButton
                              icon={<MdList />}
                              aria-label="Vue liste"
                              variant={rapportViewMode === "list" ? "solid" : "outline"}
                              colorScheme={rapportViewMode === "list" ? "blue" : "gray"}
                              size="sm"
                              onClick={() => setRapportViewMode("list")}
                            />
                          </HStack>
                          <Menu>
                            <MenuButton as={IconButton} icon={<MdMoreVert />} variant="ghost" size="sm" />
                            <MenuList>
                              <MenuItem>Options</MenuItem>
                            </MenuList>
                          </Menu>
                        </HStack>

                        {/* Affichage conditionnel selon le mode de vue */}
                        {rapportViewMode === "list" ? (
                          /* Table - Vue Liste */
                          <Card bg={cardBg} borderRadius="12px" border="1px solid" borderColor="gray.200" boxShadow="sm">
                            <TableContainer>
                              <Table variant="simple">
                                <Thead>
                                  <Tr>
                                    <Th>
                                      <Checkbox
                                        isChecked={selectedMissions.length === patientRapportsMedicaux.length && patientRapportsMedicaux.length > 0}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setSelectedMissions(patientRapportsMedicaux.map(m => m.id));
                                          } else {
                                            setSelectedMissions([]);
                                          }
                                        }}
                                      />
                                    </Th>
                                    <Th cursor="pointer">id</Th>
                                    <Th cursor="pointer">Description</Th>
                                    <Th cursor="pointer">Date de création</Th>
                                    <Th cursor="pointer">Par</Th>
                                    <Th>Actions</Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {patientRapportsMedicaux.length === 0 ? (
                                    <Tr>
                                      <Td colSpan={6} textAlign="center" py={8}>
                                        <Text color="gray.500">Aucun rapport médical disponible</Text>
                                      </Td>
                                    </Tr>
                                  ) : (
                                    patientRapportsMedicaux.map((rapport) => {
                                      const isSelected = selectedMissions.includes(rapport.id);
                                      const medecinName = rapport.medecin_nom && rapport.medecin_prenom
                                        ? `${rapport.medecin_prenom} ${rapport.medecin_nom}`
                                        : 'N/A';

                                      return (
                                        <Tr key={rapport.id} _hover={{ bg: 'gray.50' }}>
                                          <Td>
                                            <Checkbox
                                              isChecked={isSelected}
                                              onChange={(e) => {
                                                if (e.target.checked) {
                                                  setSelectedMissions([...selectedMissions, rapport.id]);
                                                } else {
                                                  setSelectedMissions(selectedMissions.filter(id => id !== rapport.id));
                                                }
                                              }}
                                            />
                                          </Td>
                                          <Td>
                                            <Text fontSize="sm" fontWeight="medium" color="gray.900">
                                              #{rapport.id}
                                            </Text>
                                          </Td>
                                          <Td>
                                            <Text fontSize="sm" color="gray.600" maxW="300px" noOfLines={2}>
                                              {rapport.description || 'Rapport médical'}
                                            </Text>
                                          </Td>
                                          <Td>
                                            <Text fontSize="sm" color="gray.600">
                                              {rapport.cree_le ? new Date(rapport.cree_le).toLocaleDateString("fr-FR") + ' ' + new Date(rapport.cree_le).toLocaleTimeString("fr-FR", { hour: '2-digit', minute: '2-digit' }) : 'N/A'}
                                            </Text>
                                          </Td>
                                          <Td>
                                            <Text fontSize="sm" color="gray.600">
                                              {medecinName}
                                            </Text>
                                          </Td>
                                          <Td>
                                            <Menu>
                                              <MenuButton
                                                as={IconButton}
                                                icon={<MdMoreVert />}
                                                variant="ghost"
                                                size="sm"
                                              />
                                              <MenuList>
                                                <MenuItem icon={<MdPictureAsPdf />} onClick={() => handleGeneratePDF(rapport)}>
                                                  Générer PDF
                                                </MenuItem>
                                                <MenuItem icon={<MdVisibility />}>Voir</MenuItem>
                                                <MenuItem icon={<MdEdit />}>Modifier</MenuItem>
                                                <MenuItem icon={<MdDelete />} color="red.500">Supprimer</MenuItem>
                                              </MenuList>
                                            </Menu>
                                          </Td>
                                        </Tr>
                                      );
                                    })
                                  )}
                                </Tbody>
                              </Table>
                            </TableContainer>

                            {/* Pagination */}
                            {patientRapportsMedicaux.length > 0 && (
                              <Flex justify="space-between" align="center" p={4} borderTop="1px solid" borderColor="gray.200">
                                <HStack spacing={2}>
                                  <Text fontSize="sm" color="gray.600">Afficher</Text>
                                  <Select
                                    value={missionItemsPerPage}
                                    onChange={(e) => {
                                      setMissionItemsPerPage(Number(e.target.value));
                                      setMissionCurrentPage(1);
                                    }}
                                    w="100px"
                                    size="sm"
                                    bg="white"
                                  >
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                  </Select>
                                  <Text fontSize="sm" color="gray.600">par page</Text>
                                </HStack>
                                <Text fontSize="sm" color="gray.600">
                                  1 à {Math.min(missionItemsPerPage, patientRapportsMedicaux.length)} sur {patientRapportsMedicaux.length}
                                </Text>
                                <HStack spacing={2}>
                                  <IconButton
                                    icon={<MdChevronLeft />}
                                    aria-label="Page précédente"
                                    size="sm"
                                    isDisabled={missionCurrentPage === 1}
                                    onClick={() => setMissionCurrentPage(prev => Math.max(1, prev - 1))}
                                  />
                                  {[...Array(Math.min(5, Math.ceil(patientRapportsMedicaux.length / missionItemsPerPage)))].map((_, i) => {
                                    const pageNum = i + 1;
                                    return (
                                      <Button
                                        key={pageNum}
                                        size="sm"
                                        variant={missionCurrentPage === pageNum ? 'solid' : 'outline'}
                                        colorScheme={missionCurrentPage === pageNum ? 'blue' : 'gray'}
                                        onClick={() => setMissionCurrentPage(pageNum)}
                                      >
                                        {pageNum}
                                      </Button>
                                    );
                                  })}
                                  <IconButton
                                    icon={<MdChevronRight />}
                                    aria-label="Page suivante"
                                    size="sm"
                                    isDisabled={missionCurrentPage >= Math.ceil(patientRapportsMedicaux.length / missionItemsPerPage)}
                                    onClick={() => setMissionCurrentPage(prev => prev + 1)}
                                  />
                                </HStack>
                              </Flex>
                            )}
                          </Card>
                        ) : (
                          /* Vue Grid - Cards */
                          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                            {patientRapportsMedicaux.length === 0 ? (
                              <Box gridColumn="1 / -1" textAlign="center" py={8}>
                                <Text color="gray.500">Aucun rapport médical disponible</Text>
                              </Box>
                            ) : (
                              patientRapportsMedicaux.map((rapport) => {
                                const medecinName = rapport.medecin_nom && rapport.medecin_prenom
                                  ? `Dr. ${rapport.medecin_prenom} ${rapport.medecin_nom}`
                                  : 'Médecin N/A';

                                return (
                                  <Card
                                    key={rapport.id}
                                    bg={cardBg}
                                    borderRadius="12px"
                                    border="1px solid"
                                    borderColor="gray.200"
                                    boxShadow="sm"
                                    p={5}
                                    _hover={{ borderColor: 'blue.300', boxShadow: 'md' }}
                                    transition="all 0.2s"
                                  >
                                    <VStack align="stretch" spacing={3}>
                                      <HStack justify="space-between">
                                        <Badge colorScheme="blue" fontSize="sm" px={3} py={1} borderRadius="full">
                                          #{rapport.id}
                                        </Badge>
                                        <Menu>
                                          <MenuButton
                                            as={IconButton}
                                            icon={<MdMoreVert />}
                                            variant="ghost"
                                            size="sm"
                                          />
                                          <MenuList>
                                            <MenuItem icon={<MdPictureAsPdf />} onClick={() => handleGeneratePDF(rapport)}>
                                              Générer PDF
                                            </MenuItem>
                                            <MenuItem icon={<MdVisibility />}>Voir</MenuItem>
                                            <MenuItem icon={<MdEdit />}>Modifier</MenuItem>
                                            <MenuItem icon={<MdDelete />} color="red.500">Supprimer</MenuItem>
                                          </MenuList>
                                        </Menu>
                                      </HStack>

                                      <Box>
                                        <Text fontSize="sm" fontWeight="600" color="gray.700" mb={1}>
                                          Description
                                        </Text>
                                        <Text fontSize="sm" color="gray.600" noOfLines={3}>
                                          {rapport.description || 'Rapport médical'}
                                        </Text>
                                      </Box>

                                      <Box>
                                        <HStack spacing={2} mb={2}>
                                          <Icon as={MdAccessTime} color="gray.500" boxSize={4} />
                                          <Text fontSize="xs" color="gray.500">
                                            {rapport.cree_le ? new Date(rapport.cree_le).toLocaleDateString("fr-FR") + ' ' + new Date(rapport.cree_le).toLocaleTimeString("fr-FR", { hour: '2-digit', minute: '2-digit' }) : 'Date N/A'}
                                          </Text>
                                        </HStack>
                                        <HStack spacing={2}>
                                          <Icon as={MdLocalHospital} color="blue.500" boxSize={4} />
                                          <Text fontSize="xs" color="gray.600" fontWeight="500">
                                            {medecinName}
                                          </Text>
                                        </HStack>
                                      </Box>

                                      <Button
                                        size="sm"
                                        colorScheme="blue"
                                        variant="outline"
                                        leftIcon={<MdPictureAsPdf />}
                                        onClick={() => handleGeneratePDF(rapport)}
                                        w="full"
                                      >
                                        Générer PDF
                                      </Button>
                                    </VStack>
                                  </Card>
                                );
                              })
                            )}
                          </SimpleGrid>
                        )}
                      </VStack>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </Box>
  );
} 